import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TokenAuthMutation } from 'src/graphql';
import { ELsKey, ls } from 'src/utils/localStorage';

export type TAuthState = {
  tokenAuth: TokenAuthMutation['tokenAuth'] | null;
};

export const initialAuthState: TAuthState = {
  tokenAuth: ls.get(ELsKey.TOKEN_AUTH) || null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    setTokenAuth(state, action: PayloadAction<TAuthState['tokenAuth']>) {
      state.tokenAuth = action.payload;
    },
  },
});

// Actions
export const { setTokenAuth } = authSlice.actions;

// Reducer
export const authReducer = authSlice.reducer;
